// @flow

import PropTypes               from 'prop-types';
import * as  React             from 'react';
import * as Reactstrap         from 'reactstrap';
import * as  Recompose         from 'recompose';
import styled                  from 'styled-components';
import type { ThemeBaseColor } from '../../../../theme/theme.types';


// -----------------------------------------------------------------------------------------------------------------
// Main component
// -----------------------------------------------------------------------------------------------------------------

export type CardProps = {|
  children: React.Node,
  color?: ThemeBaseColor,
  className?: string,
|};

export type CardHeaderProps = {};
export type CardTitleProps = {};
export type CardBodyProps = {};
export type CardTextProps = {};

type CardComponents = {
  Card: React.ComponentType<CardProps>,
  Header: React.ComponentType<CardHeaderProps>,
  Title: React.ComponentType<CardTitleProps>,
  Body: React.ComponentType<CardBodyProps>,
  Text: React.ComponentType<CardTextProps>,
}

const contextTypes = {color: PropTypes.string.isRequired};

const stripNonPresentationProps = Recompose.compose(
  Recompose.setDisplayName('PresentationProps'),
  Recompose.mapProps(({color, ...props}) => props),
);

const Card: CardComponents = {
  Card:   Recompose.withContext(
    contextTypes,
    props => ({color: props.color || 'primary'}),
  )(styled(stripNonPresentationProps(Reactstrap.Card))`
  border-radius: 0;
  border-color: ${props => props.theme.colors[props.color || 'primary']};
  ${props => props.theme.textRules[props.color || 'primary']};

  & p:last-child {
    margin-bottom: 0;
  }
`),
  Header: Recompose.getContext(contextTypes)(styled(stripNonPresentationProps(Reactstrap.CardHeader))`
  && {
    ${props => props.theme.textRules[`${props.color}Inverse`]}
        border-radius: 0;
  }
`),
  Title:  Reactstrap.CardTitle,
  Body:   Reactstrap.CardBody,
  Text:   Reactstrap.CardText,
};


// -----------------------------------------------------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------------------------------------------------
export default Card;



// WEBPACK FOOTER //
// ./src/modules/reactstrap/components/Card/Card.js